/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Self_Hosted_CostInputs */



/**
* | output |
* | --- |
* | "Your infrastructure · €0 in oneAI." |
*
* @param {Model_Showcase_Self_Hosted_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_self_hosted_cost = /** @type {((inputs?: Model_Showcase_Self_Hosted_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Self_Hosted_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigene Infrastruktur · 0 € in oneAI.")
	return /** @type {LocalizedString} */ ("Your infrastructure · €0 in oneAI.")
});